import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { HealthProfileCategoryLayout } from '@/modules/profile/components/health-parameter-layout/HealthParameterLayout'
import { AllergiesHealthParameterSection } from '@/modules/profile/pages/health/tabs/allergies/AllergiesHealthParameterSection'
import { AllergyList } from '@/modules/shared/components/allergy-list/AllergyList'

import type { AllergyIntolerances, AllergyProfile } from '@/modules/app/types/HealthParameter.types'
import type { DataPoint } from '@/modules/shared/components/data-point/data-point-entry/DataPointEntry'

type StoredAllergyData = {
  synops: AllergyIntolerances[]
  user: string
}

type AllergyAnswerProps = {
  title: string
  description: string
  allergyScheme?: AllergyProfile
  storedAllergyData?: StoredAllergyData
}

export const AllergyAnswer = ({ title, description, allergyScheme, storedAllergyData }: AllergyAnswerProps) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.Spacing.Space2}>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {`${title && description ? `${title}: ` : title || ''}${description}`}
      </Span>
      {allergyScheme ? (
        <AllergyList
          allergies={allergyScheme.allergies.filter((a) => a.diffStatus !== 'deleted')}
          schemeStatus={allergyScheme.schemeStatus}
        />
      ) : storedAllergyData ? (
        <StoredAllergyDisplay data={storedAllergyData} />
      ) : (
        <AllergiesHealthParameterSection showDescriptions={false} />
      )}
    </FlexColumn>
  )
}

const StoredAllergyDisplay = ({ data }: { data: StoredAllergyData }) => {
  const synopsDataPoints: DataPoint[] =
    data.synops?.map((allergyIntolerance) => ({
      label: allergyIntolerance.display,
      value: allergyIntolerance.reaction?.join(', '),
      date: allergyIntolerance.recordedDate,
    })) || []

  const userDataPoint: DataPoint | undefined = data.user ? { label: data.user, value: undefined } : undefined

  return (
    <HealthProfileCategoryLayout
      synopsDataPoints={synopsDataPoints.length > 0 ? synopsDataPoints : undefined}
      userDataPoint={userDataPoint}
      showDescriptions={false}
    />
  )
}
